import { useQuery } from '@tanstack/react-query'
import { landscapeApi } from '../api/landscape'
import { useSpoke } from './useSpoke'

// One hook for "what exists for me": the shell builds its navigation from it and locked routes 404.
export function useLandscape() {
  const spoke = useSpoke()
  return useQuery({ queryKey: ['landscape', spoke], queryFn: () => landscapeApi.get(spoke), staleTime: 15_000 })
}
